import { Component } from 'preact';

export default class ClusterMarker extends Component {
    render() {
        const { pointCount, onClick } = this.props;
        return (
            <div onClick={onClick} className="cluster-marker">
                {pointCount}
            </div>
        );
    }
}